<ng-container [formGroup]="form">
  <div [hidden]="activeLocale !== activeOrg.locale.split('-')[0]">
    <ng-container *ngIf="smartCodes">
      <textarea
        appSmartcodePreview
        [name]="name"
        [id]="name"
        [rows]="rows"
        class="form-control data-hj-whitelist {{ class }}"
        [formControlName]="name"
        [refresh]="refresh"
        [account]="account"
        [organization]="activeOrg"
        [document]="document"
        placeholder="{{ placeholder | translate }}"
      ></textarea>
    </ng-container>
    <ng-container *ngIf="!smartCodes">
      <textarea
        [name]="name"
        [id]="name"
        [rows]="rows"
        class="form-control data-hj-whitelist {{ class }}"
        [formControlName]="name"
        placeholder="{{ placeholder | translate }}"
      ></textarea>
    </ng-container>
  </div>

  <ng-container *ngIf="l10nCtrl" formGroupName="l10n">
    <ng-container *ngFor="let l of l10n">
      <div [hidden]="l !== activeLocale">
        <ng-container *ngIf="smartCodes">
          <textarea
            appSmartcodePreview
            type="text"
            class="form-control data-hj-whitelist {{ class }}"
            [rows]="rows"
            autocomplete="off"
            [name]="name + '_' + l"
            [id]="name + '_' + l"
            [formControlName]="name + '_' + l"
            [refresh]="refresh"
            [account]="account"
            [organization]="activeOrg"
            [document]="document"
            placeholder="{{ placeholder | translate }}"
          >
          </textarea>
        </ng-container>
        <ng-container *ngIf="!smartCodes">
          <textarea
            type="text"
            class="form-control data-hj-whitelist {{ class }}"
            [rows]="rows"
            autocomplete="off"
            [name]="name + '_' + l"
            [id]="name + '_' + l"
            [formControlName]="name + '_' + l"
            placeholder="{{ placeholder | translate }}"
          >
          </textarea>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <app-input-flags
    class="row pr-3"
    [activeOrg]="activeOrg"
    [alignRight]="alignFlagsRight"
    [activeLocale]="activeLocale"
    [hidable]="hidableFlags"
    (selected)="onSelectInputLang($event)"
    *appIfWl="true;key: 'input-flags'"
  ></app-input-flags>
</ng-container>
